import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-[60vh] flex-col items-center justify-center overflow-hidden px-4 py-20 text-center">
      <div className="absolute -top-10 left-1/2 -translate-x-1/2 select-none font-heading text-[10rem] font-black leading-none text-background-100/70 md:text-[16rem]">
        404
      </div>
      <div className="relative z-10 flex flex-col items-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
          <i className="ri-spy-line text-xl" aria-hidden="true"></i>
        </span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
          这条线索似乎断了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
          你要访问的页面不存在或已被移除。回到首页，继续寻找下一个烧脑真相吧。
        </p>
        <p className="mt-2 font-mono text-xs text-foreground-600">{location.pathname}</p>
        <Link
          to="/"
          className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-left-line" aria-hidden="true"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}